import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useTranslation } from 'react-i18next';
import { getNumberOfPages, getPageFromQuery, locationWithPageNumber } from 'utils/pagination';
import { useFetchMyHistoryContent, PROFILE_ITEMS_PER_PAGE } from 'actions/content';
import Box from 'components/Box';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Pagination from 'components/Pagination';
import HeadingWithFilters from '../HeadingWithFilters';
import ContentTypeFilter from '../ContentTypeFilter';
import StatusFilter from '../StatusFilter';
import ItemsGrid from '../ItemsGrid';
function History() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var type = queryParams.type,
    status = queryParams.status;
  var page = getPageFromQuery({
    query: queryParams
  });
  var _useFetchMyHistoryCon = useFetchMyHistoryContent({
      type: type,
      status: status,
      page: page
    }),
    items = _useFetchMyHistoryCon.items,
    isLoading = _useFetchMyHistoryCon.isLoading,
    isError = _useFetchMyHistoryCon.isError,
    total = _useFetchMyHistoryCon.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: PROFILE_ITEMS_PER_PAGE
  });
  var hasFilters = type && type !== 'all' || status && status !== 'all';
  var emptyContent = hasFilters ? t('error_no_filter_results') : t('error_no_viewed_or_completed_content');
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(HeadingWithFilters, {
    heading: /*#__PURE__*/React.createElement(Heading, {
      as: "h2"
    }, t('history_title'))
  }, /*#__PURE__*/React.createElement(ContentTypeFilter, null), /*#__PURE__*/React.createElement(StatusFilter, null)), /*#__PURE__*/React.createElement(ItemsGrid, {
    items: items,
    isError: isError,
    isLoading: isLoading,
    emptyContent: emptyContent,
    priorityPillType: "latestInteraction"
  }), pageCount > 1 && /*#__PURE__*/React.createElement(Box, {
    mt: "m"
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageCount: pageCount,
    currentPage: page,
    getPageLink: function getPageLink(pageNumber) {
      return locationWithPageNumber({
        location: location,
        page: pageNumber
      });
    }
  })));
}
export default History;